<template>
  <template v-if="!loading && !initialLoading">
    <LandingSafety v-if="isSafetyCatalog" />
    <LandingVision v-else />
    <SwitchCatalogOnboard
      :show-modal="showModal"
      :hide-sign-in="isCorpPerkStore"
      @catalog-selected="switchCatalog"
      @close="onboardStore.setSwitchCatalogOnboarded(true)"
    />
  </template>
  <template v-else>
    <ZnLoadingBar />
  </template>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { navigateTo, computed, ref, onMounted, definePageMeta } from '#imports'
import { useGuestStore } from '~/store/guest'
import { useOnboardStore } from '~/store/onboard'

definePageMeta({
  discountBanner: true,
  middleware: (to) => {
    const { gift, isZunniesStore } = useGuestStore()

    if (isZunniesStore && gift?.id === to.query.gift) {
      return navigateTo('/products/list/sports', { external: true })
    }
  },
})

const initialLoading = ref(true)

const guestStore = useGuestStore()
const {
  isSafetyCatalog,
  loading,
  isZunniesStore,
  isCorpPerkStore,
  isGuestMode,
  hasMultipleGuestCatalogs,
} = storeToRefs(guestStore)

const onboardStore = useOnboardStore()
const { switchCatalogOnboarded } = storeToRefs(onboardStore)

const switchCatalog = (catalog: 'vision' | 'safety') => {
  guestStore.switchSelectedCatalog(catalog)
  onboardStore.setSwitchCatalogOnboarded(true)
  onboardStore.setSwitchCatalogCtaShown(false)
}

onMounted(() => {
  if (!isZunniesStore.value) {
    initialLoading.value = false
  }
})

const showModal = computed(
  () =>
    isGuestMode.value &&
    hasMultipleGuestCatalogs.value &&
    !switchCatalogOnboarded.value,
)
</script>
